import createReactComponent from '../createReactComponent';
export default createReactComponent('outline', 'letter-n', 'IconLetterN', [["path",{"d":"M7 20v-16l10 16v-16","key":"svg-0"}]]);